/* Mangamta theme — core interactions (vanilla JS, no dependencies) */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Mobile menu drawer ---------------- */
  var menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  var menuDrawer = document.querySelector('[data-mobile-menu-drawer]');
  var menuClose = document.querySelector('[data-mobile-menu-close]');
  var overlay = document.querySelector('[data-drawer-overlay]');

  function openMenu() {
    menuDrawer && menuDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menuDrawer && menuDrawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  overlay && overlay.addEventListener('click', function () {
    closeMenu();
    closeCart();
  });

  /* ---------------- Cart drawer ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOpeners = document.querySelectorAll('[data-cart-open]');
  var cartClose = document.querySelector('[data-cart-close]');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartOpeners.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.dataset.cartOpen === 'drawer') {
        e.preventDefault();
        openCart();
      }
    });
  });
  cartClose && cartClose.addEventListener('click', closeCart);

  /* Quick Add (product cards / collection grid) */
  document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); // stop the parent <a> from navigating
      e.stopPropagation();

      if (btn.disabled || btn.dataset.loading === 'true') return;

      var handle = btn.dataset.productHandle;
      if (!handle) return;

      var originalText = btn.textContent;
      btn.dataset.loading = 'true';
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/products/' + handle + '.js', { cache: 'no-store', credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('Could not load product');
          return res.json();
        })
        .then(function (product) {
          var variant = product.variants.find(function (v) { return v.available; });
          if (!variant) throw new Error('This item is sold out');

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            cache: 'no-store',
            credentials: 'same-origin',
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add item to cart');
            return data;
          });
        })
        .then(function () {
          openCart();
          var cacheBuster = '&_=' + Date.now();
          return fetch(window.location.pathname + '?sections=header,cart-drawer' + cacheBuster, {
            cache: 'no-store',
            credentials: 'same-origin'
          })
            .then(function (res) { return res.json(); })
            .then(function (sections) {
              updateCartCountFromHtml(sections['header']);
              updateCartDrawerFromHtml(sections['cart-drawer']);
            });
        })
        .catch(function (err) {
          console.error('Quick add failed', err);
          btn.textContent = err.message.length < 20 ? err.message : 'Error — try again';
          setTimeout(function () { btn.textContent = originalText; }, 2000);
        })
        .finally(function () {
          btn.dataset.loading = 'false';
          btn.disabled = false;
        });
    });
  });
  /* ---------------- Hero slider ---------------- */
  document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-hero-slide]');
    var dots = slider.querySelectorAll('[data-hero-dot]');
    var current = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval || '6000', 10);
    var timer;

    function show(index) {
      slides.forEach(function (s, i) { s.style.display = i === index ? '' : 'none'; });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
      current = index;
    }
    function next() { show((current + 1) % slides.length); }
    function prev() { show((current - 1 + slides.length) % slides.length); }

    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); restart(); }); });
    var nextBtn = slider.querySelector('[data-hero-next]');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    nextBtn && nextBtn.addEventListener('click', function () { next(); restart(); });
    prevBtn && prevBtn.addEventListener('click', function () { prev(); restart(); });

    function restart() {
      clearInterval(timer);
      if (autoplay) timer = setInterval(next, interval);
    }
    if (slides.length) { show(0); restart(); }
  });

  /* ---------------- Announcement bar slider ---------------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = bar.querySelectorAll('[data-announcement-msg]');
    var i = 0;
    if (msgs.length <= 1) return;
    function show(idx) { msgs.forEach(function (m, k) { m.style.display = k === idx ? '' : 'none'; }); }
    show(0);
    var next = bar.querySelector('[data-announcement-next]');
    var prev = bar.querySelector('[data-announcement-prev]');
    next && next.addEventListener('click', function () { i = (i + 1) % msgs.length; show(i); });
    prev && prev.addEventListener('click', function () { i = (i - 1 + msgs.length) % msgs.length; show(i); });
    setInterval(function () { i = (i + 1) % msgs.length; show(i); }, 5000);
  });

  /* ---------------- Tabs (Trendy Collection) ---------------- */
  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var buttons = wrap.querySelectorAll('[data-tab-btn]');
    var panels = wrap.querySelectorAll('[data-tab-panel]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.dataset.tabBtn;
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.tabPanel === target); });
      });
    });
  });

  /* ---------------- Carousels (horizontal scroll with arrows) ---------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    var prev = wrap.querySelector('[data-carousel-prev]');
    var next = wrap.querySelector('[data-carousel-next]');
    if (!track) return;
    function scrollAmount() {
      var card = track.querySelector(':scope > *');
      return card ? card.getBoundingClientRect().width + 26 : 300;
    }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }); });
  });

  /* ---------------- Countdown timers ---------------- */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var end = new Date(el.dataset.countdown).getTime();
    var daysEl = el.querySelector('[data-cd-days]');
    var hoursEl = el.querySelector('[data-cd-hours]');
    var minsEl = el.querySelector('[data-cd-mins]');
    var secsEl = el.querySelector('[data-cd-secs]');
    function tick() {
      var diff = Math.max(0, end - Date.now());
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (daysEl) daysEl.textContent = d;
      if (hoursEl) hoursEl.textContent = ('0' + h).slice(-2);
      if (minsEl) minsEl.textContent = ('0' + m).slice(-2);
      if (secsEl) secsEl.textContent = ('0' + s).slice(-2);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------------- Product gallery thumbnails ---------------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main-img]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.fullSrc || thumb.src;
      });
    });
  });

  /* ---------------- Metal / variant swatches ---------------- */
  document.querySelectorAll('[data-metal-swatches]').forEach(function (group) {
    var buttons = group.querySelectorAll('[data-metal-swatch]');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var variantId = btn.dataset.variantId;
        var input = document.querySelector('[data-variant-id-input]');
        if (input && variantId) input.value = variantId;
      });
    });
  });

  /* ---------------- Quantity selector ---------------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    minus && minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    plus && plus.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------------- Wishlist (local, no backend) ---------------- */
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.classList.toggle('is-active');
    });
  });

  /* ---------------- Testimonial slider ---------------- */
  document.querySelectorAll('[data-testimonial-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('[data-testimonial-slide]');
    var dots = slider.querySelectorAll('[data-testimonial-dot]');
    var i = 0;
    function show(idx) {
      slides.forEach(function (s, k) { s.style.display = k === idx ? '' : 'none'; });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { i = k; show(i); }); });
    if (slides.length > 1) {
      show(0);
      setInterval(function () { i = (i + 1) % slides.length; show(i); }, 6000);
    }
  });

  /* ---------------- Grid view toggle on collection page ---------------- */
  document.querySelectorAll('[data-grid-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cols = btn.dataset.gridToggle;
      var grid = document.querySelector('[data-product-grid]');
      var toggles = document.querySelectorAll('[data-grid-toggle]');
      toggles.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (grid) grid.style.setProperty('--grid-cols', cols);
    });
  });

  /* Close drawers with Escape key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeCart(); }
  });
});
